export class CreateApplicationStakeholdersItamsConstants {
    static TRADER_LABEL = "Traders";
    static TRADER_FORM_ARRAY_NAME = "traders";
    static TRADERS_LOOKUP_NAME = "Traders";
    static TRADERS_CONTROL_NAME = "traders";
    static TRADERS_FORM_GROUP_NAME = "tradersForm";
    static STAKEHOLDERS_HEADER = "Traders";
    static COPY_APPLICANT_TO_TRADER_BUTTON_LABEL = "Copy applicant to trader";
}
